import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import axios from 'axios';
import VehicleCard from '../components/VehicleCard';
import { FaFilter, FaSearch } from 'react-icons/fa';

const VehiclesPage = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const [filters, setFilters] = useState({
    make: '',
    model: '',
    minYear: '',
    maxYear: '',
    minPrice: '',
    maxPrice: ''
  });

  useEffect(() => {
    const fetchVehicles = async () => {
      try {
        const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/vehicles', {
          params: filters
        });
        setVehicles(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching vehicles:', error);
        setLoading(false);
      }
    };

    const fetchMakes = async () => {
      try {
        const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/vehicles');
        const uniqueMakes = [...new Set(data.map(v => v.make))];
        setMakes(uniqueMakes);
      } catch (error) {
        console.error('Error fetching makes:', error);
      }
    };

    fetchVehicles();
    fetchMakes();
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));

    // Reset models when make changes
    if (name === 'make') {
      setFilters(prev => ({
        ...prev,
        model: ''
      }));
    }
  };

  const handleModelFetch = async (make) => {
    if (!make) return;
    try {
      const { data } = await axios.get('https://backend.stu89674.webhosting.arden.ac.uk/api/vehicles', {
        params: { make }
      });
      const uniqueModels = [...new Set(data.map(v => v.model))];
      setModels(uniqueModels);
    } catch (error) {
      console.error('Error fetching models:', error);
    }
  };

  return (
    <Container>
      <h1 className="my-4">Browse Vehicles</h1>
      
      <Row>
        <Col md={3}>
          <div className="filter-section sticky-top" style={{ top: '20px' }}>
            <h5><FaFilter className="me-2" />Filters</h5>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Make</Form.Label>
                <Form.Select 
                  name="make" 
                  value={filters.make}
                  onChange={handleFilterChange}
                  onFocus={() => handleModelFetch(filters.make)}
                >
                  <option value="">All Makes</option>
                  {makes.map(make => (
                    <option key={make} value={make}>{make}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Model</Form.Label>
                <Form.Select 
                  name="model" 
                  value={filters.model}
                  onChange={handleFilterChange}
                  disabled={!filters.make}
                >
                  <option value="">All Models</option>
                  {models.map(model => (
                    <option key={model} value={model}>{model}</option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Year Range</Form.Label>
                <div className="d-flex">
                  <Form.Control
                    type="number"
                    placeholder="Min"
                    name="minYear"
                    value={filters.minYear}
                    onChange={handleFilterChange}
                  />
                  <span className="mx-2">to</span>
                  <Form.Control
                    type="number"
                    placeholder="Max"
                    name="maxYear"
                    value={filters.maxYear}
                    onChange={handleFilterChange}
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Price Range ($)</Form.Label>
                <div className="d-flex">
                  <Form.Control
                    type="number"
                    placeholder="Min"
                    name="minPrice"
                    value={filters.minPrice}
                    onChange={handleFilterChange}
                  />
                  <span className="mx-2">to</span>
                  <Form.Control
                    type="number"
                    placeholder="Max"
                    name="maxPrice"
                    value={filters.maxPrice}
                    onChange={handleFilterChange}
                  />
                </div>
              </Form.Group>

              <Button variant="primary" className="w-100">
                <FaSearch className="me-2" />
                Apply Filters
              </Button>
            </Form>
          </div>
        </Col>

        <Col md={9}>
          {loading ? (
            <div className="text-center py-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : vehicles.length === 0 ? (
            <div className="text-center py-5">
              <h4>No vehicles found matching your criteria</h4>
              <Button 
                variant="outline-primary" 
                onClick={() => setFilters({
                  make: '',
                  model: '',
                  minYear: '',
                  maxYear: '',
                  minPrice: '',
                  maxPrice: ''
                })}
              >
                Clear Filters
              </Button>
            </div>
          ) : (
            <Row>
              {vehicles.map((vehicle) => (
                <Col key={vehicle.vehicle_id} sm={12} md={6} lg={4} className="mb-4">
                  <VehicleCard vehicle={vehicle} />
                </Col>
              ))}
            </Row>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default VehiclesPage;